/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Decimal } from 'decimal.js';

import {
  FulfillmentPrice,
  FulfillmentPriceData,
} from './fulfillmentPrice';
import {
  ItemPrice,
  ItemPriceData,
} from './itemPrice';

export type OrderPriceData = ItemPriceData & FulfillmentPriceData;

export class OrderPrice {
  private readonly itemPrice: ItemPrice;
  private readonly fulfillmentPrice: FulfillmentPrice;

  constructor(
    currency: string,
    data: OrderPriceData,
  ) {
    this.itemPrice = new ItemPrice(currency, data);
    this.fulfillmentPrice = new FulfillmentPrice(currency, data);
  }

  get currency() {
    return this.itemPrice.currency;
  }

  get total() {
    return {
      amount: this.subtotal.amount.add(this.shipping.amount),
      currency: this.currency,
    };
  }

  get subtotal() {
    return this.itemPrice.principal;
  }

  get shipping() {
    return this.fulfillmentPrice.shipping;
  }
}
